import {
    ArrowDownTrayIcon,
    DocumentArrowDownIcon,
    EyeIcon,
    InformationCircleIcon
} from '@heroicons/react/24/outline';
import { RETENTION_DOCUMENTS } from '../../constants/retentionDocuments';

// Shared "case complete" content for retention: the signable retention
// documents + retainer delivery-day instructions. Rendered in the
// UploadRetentionRecordsModal congratulations step (refinement outside-ODO
// path).
const RetentionCongratsContent: React.FC = () => (
    <>
        <p className="text-sm text-gray-600">
            Congratulations on completing this case! Please review the retention documents below and
            sign them with your patient for your internal records. These documents are also
            accessible at any time in the Resource Center.
        </p>

        {/* Retention Documents */}
        <div className="grid grid-cols-2 gap-4">
            {RETENTION_DOCUMENTS.map((doc) => (
                <div
                    key={doc.id}
                    className="flex flex-col items-center gap-3 bg-gray-50 rounded-xl border border-gray-200 p-4"
                >
                    <DocumentArrowDownIcon className="w-9 h-9 text-[#3773A8]" />
                    <span className="text-xs text-gray-700 font-medium text-center">
                        {doc.label}
                    </span>
                    <div className="flex items-center gap-1.5">
                        <a
                            href={doc.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="p-1.5 rounded-md border border-gray-300 bg-white hover:bg-gray-100 transition-colors"
                            title="Preview"
                        >
                            <EyeIcon className="w-4 h-4 text-gray-600" />
                        </a>
                        <a
                            href={doc.url}
                            download
                            target="_blank"
                            rel="noopener noreferrer"
                            className="p-1.5 rounded-md border border-gray-300 bg-white hover:bg-gray-100 transition-colors"
                            title="Download"
                        >
                            <ArrowDownTrayIcon className="w-4 h-4 text-gray-600" />
                        </a>
                    </div>
                </div>
            ))}
        </div>

        {/* Retainer Delivery Instructions */}
        <div className="bg-blue-50 rounded-xl p-5 flex gap-4">
            <InformationCircleIcon className="w-6 h-6 text-[#3773A8] flex-shrink-0 mt-0.5" />
            <div>
                <p className="text-sm font-bold text-gray-800 mb-2">
                    Retainer delivery day instructions
                </p>
                <ul className="space-y-1.5">
                    <li className="text-sm text-gray-700 flex items-start gap-2">
                        <span className="mt-1.5 w-1.5 h-1.5 bg-[#3773A8] rounded-full flex-shrink-0" />
                        Once retainers are delivered, please verify proper fit and document it.
                        Dental Monitoring will not be resumed.
                    </li>
                    <li className="text-sm text-gray-700 flex items-start gap-2">
                        <span className="mt-1.5 w-1.5 h-1.5 bg-[#3773A8] rounded-full flex-shrink-0" />
                        The case will be marked as complete once retainers are marked as delivered.
                    </li>
                </ul>
            </div>
        </div>
    </>
);

export default RetentionCongratsContent;
